import { AppShell, PilotDisclaimer } from "@/components/AppShell";
import { useLang } from "@/context/LangContext";

export default function Help() {
  const { tr } = useLang();
  return (
    <AppShell>
      <section className="px-5 pt-4 pb-10 space-y-4" data-testid="help-screen">
        <h1 className="text-[22px] font-bold text-[rgb(var(--wpe-navy))]" data-testid="help-title">
          {tr("helpTitle")}
        </h1>
        <div className="wpe-card space-y-2">
          <h2 className="wpe-eyebrow">{tr("faqPractice")}</h2>
          <p className="text-[13px] text-[rgb(var(--wpe-slate))]">{tr("heroSub")}</p>
        </div>
        <div className="wpe-card space-y-2">
          <h2 className="wpe-eyebrow">{tr("faqAI")}</h2>
          <p className="text-[13px] text-[rgb(var(--wpe-slate))]">{tr("faqAIText")}</p>
        </div>
        <div className="wpe-card space-y-2">
          <h2 className="wpe-eyebrow">{tr("faqPronunciation")}</h2>
          <p className="text-[13px] text-[rgb(var(--wpe-slate))]">{tr("faqPronText")}</p>
        </div>
        <div className="wpe-card space-y-2">
          <h2 className="wpe-eyebrow">{tr("faqPrivacy")}</h2>
          <p className="text-[13px] text-[rgb(var(--wpe-slate))]">{tr("faqPrivacyText")}</p>
        </div>
        <div className="wpe-card space-y-2">
          <h2 className="wpe-eyebrow">{tr("installHome")}</h2>
          <p className="text-[13px] text-[rgb(var(--wpe-slate))]">{tr("installHint")}</p>
        </div>
        <PilotDisclaimer />
      </section>
    </AppShell>
  );
}
